import * as React from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import AdminConfig from "@system/config/admin";
import Constants from 'src/helper/Constants';
import ShowAlert from "../../component/Global/ShowAlert";
import { LicenseManager } from 'ag-grid-enterprise';
import System from 'src/helper/system';

const AdminConsoleHeader = (props) => {
    LicenseManager.setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-056206}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Avnet,_Inc.}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Charts_and_AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{8_April_2025}____[v3]_[0102]_MTc0NDA2NjgwMDAwMA==cf84f96f564ac2682d3fb4562a2ca4cb");
    const { translation:t } = System;
    const { title, tab, header = t('adminConsole') } = props;
    const { adminConsoleTab: { User, MainTab, BomDetails } } = Constants

    const redirectUserConsole = () => {
        if (tab !== User && tab !== MainTab && tab !== BomDetails) {
            window.location.href = AdminConfig.getAdminURL();
        }
        else if (tab == BomDetails) {
            window.location.href = AdminConfig.getBomManagerURL();
        }
    }

    return (
        <>
            <div className='container'>
                <div className="adminconsole-head header-container d-flex align-items-center justify-content-between">
                    <div className={`page-title font-oswald font-light font-38 text-green ${tab !== User && tab !== MainTab ? 'cursor-pointer' : 'cursor-default'}`} onClick={() => redirectUserConsole()}>{header}</div>
                </div>
                <div className="pcn-line-divider"></div>
                <div className="page-title font-oswald font-light font-30">{title}</div>
                <ShowAlert onlyShowMessage={['adminconsole', 'AdminOrderError', 'reprocessOrder']} />
            </div>
        </>
    );
}

export default AdminConsoleHeader;